import React from 'react';
import { graphql } from 'gatsby';
import EmployeeCard from '../employee-card';
import * as styles from './styles.module.sass';
import Layout from '../layout';

const EmployeeList = ({ data }) => {
    return (
        <Layout>
            <ul className={styles.employeeList}>
                {data.allContentfulEmployee.edges.map(({ node }, index) => {
                    if (!node.isActive) return null;
                    return (
                        <li key={index} className={styles.employeeListItem}>
                            <EmployeeCard employee={node} />
                        </li>
                    );
                })}
            </ul>
        </Layout>
    );
};

export const query = graphql`
    query EmployeeQuery($departmentName: String) {
        allContentfulEmployee(
            filter: { department: { name: { eq: $departmentName } } }
            sort: { fields: order, order: DESC }
        ) {
            edges {
                node {
                    isActive
                    lastName
                    isMale
                    list
                    mobilePhoneNumber
                    phoneNumberSuffix
                    subline
                    order
                    portraitImage {
                        gatsbyImageData(quality: 85)
                        title
                    }
                    firstName
                    faxNumberSuffix
                    emailAddressPrefix
                    department {
                        name
                        order
                    }
                }
            }
        }
    }
`;

export default EmployeeList;
